<template>
    <div class="createWord">
        <div class="header flex-align-between">
            <span>当前位置：我的字帖 > 自定义字帖</span>
            <div class="back flex-align">
                <img :src="require('../../assets/task/return.png')" @click="goback" />
                <span @click="goback">返回</span>
            </div>
        </div>
        <div class="content flex-align">
            <div class="left">
                <span class="title">
                    {{ $route.query.type == 1 ? '课堂写字单' : $route.query.type == 2 ? '篇章字帖' : '生字字帖' }}
                </span>
                <div class="preview">
                    <div class="preview_wrap flex-column-center">
                        <span class="preview1">预览</span>
                        <div class="imgWrap">
                            <img :src="coverUrl">
                        </div>
                    </div>
                </div>
            </div>
            <div class="right">
                <span class="title">字帖详情</span>
                <div class="wordContent flex-column">
                    <div class="line"></div>
                    <span class="wordName">字帖名称:</span>
                    <el-input placeholder="请输入内容" v-model="name" maxlength="30" show-word-limit clearable
                        :disabled="!formEditable">
                    </el-input>
                    <span class="span2">绑定学生:</span>
                    <div class="bindStu flex-align">
                        <el-select v-model="bindStu" placeholder="请选择班级" @change="changeClass"
                            :disabled="!formEditable">
                            <el-option v-for="(item, index) in classList" :key="index" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                        <span>(已选{{ bindStuList.length || 0 }}人)</span>
                        <div class="selectStu flex-align" :class="{ 'is-disabled': !formEditable }"
                            @click="chooseStu(bindStu)">
                            <img src="@/assets/copybook/add4.png" alt="">
                            选择学生
                        </div>
                    </div>
                    <div class="words flex-align-between">
                        <span>字帖内容:</span>
                        <div class="delete flex-align" :class="{ 'is-disabled': !formEditable }" @click="clear">
                            <img src="@/assets/copybook/delete.png" alt="">
                            清空
                        </div>
                    </div>
                    <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="textarea" @input="handleInput"
                        :disabled="!formEditable">
                    </el-input>
                    <div class="wordCount">{{ currentChineseCount }}/{{ maxChineseCount }}</div>
                    <div class="fastInput flex-align" :class="{ 'is-disabled': !formEditable }">
                        <span>快捷输入:</span>
                        <span class="grade" v-for="(item, index) in fastList" :key="index"
                            @click="chooseWrod(item.grade, item.name)">{{ item.name }}、</span>
                    </div>
                    <!-- <span class="span3">格子类型:</span>
                    <div class="imgs flex-align">
                        <img :src="gridType==1?require('@/assets/copybook/tian_active.png'):require('@/assets/copybook/mi3.png')"
                            @click="chooseGrid(1)">
                        <img :src="gridType==2?require('@/assets/copybook/mi_active.png'):require('@/assets/copybook/mi1.png')"
                            @click="chooseGrid(2)">
                        <img :src="gridType==0?require('@/assets/copybook/empty_active.png'):require('@/assets/copybook/mi2.png')"
                            @click="chooseGrid(0)">
                    </div> -->
                    <div class="btnWrap flex-align">
                        <el-upload class="upload-bg" v-if="$route.query.color == 1" action="" :show-file-list="false" accept="image/*"
                            :disabled="!replaceBgActive" :http-request="uploadBackground">
                            <div class="replaceBg" :class="replaceBgActive ? 'replaceBg-active' : 'replaceBg-disabled'">
                                替换背景</div>
                        </el-upload>
                        <div v-if="isEditMode" class="editBtn"
                            :class="!isEditing ? 'editBtn-active' : 'editBtn-disabled'" @click="startEdit">编辑</div>
                        <div class="make" :class="[isMake ? 'active' : 'disabled']" @click="create">
                            {{ isEditMode ? '重新生成' : '生成字帖' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 生成字帖弹窗 -->
        <el-dialog custom-class="myDialog" :visible='dialogVisible' :before-close="handleClose" center title="生成字帖">
            <div class="tipWrap flex-column-center">
                <span>正在生成字帖，这个过程需要几分钟...</span>
                <span>您可先进行其他操作,字帖生成后会保存在</span>
                <span>"我创建的"中</span>
                <div class="check" @click="check">去查看</div>
            </div>
        </el-dialog>
        <!-- 绑定学生弹窗 -->
        <el-dialog custom-class="bindStuDialog" :visible='dialogVisible2' :before-close="handleClose" center
            title="绑定学生">
            <div class="bindWrap flex-align-between">
                <span>{{ schoolName }}-{{ className }}</span>
                <el-input placeholder="请输入学生姓名" v-model="searchName" @input="searchStu" suffix-icon="el-icon-search">
                </el-input>
            </div>
            <el-table :data="tableData" stripe style="width: 100%" height="300"
                @selection-change="handleSelectionChange">
                <el-table-column width="150" align="center">
                    <template slot="header">
                        <el-checkbox v-model="allSelect" @change="changeAll">全选</el-checkbox>
                    </template>
                    <template slot-scope="scope">
                        <el-checkbox v-model="scope.row.select" @change="selectStu(scope.row.id, scope.row.select)">
                        </el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="姓名" width="150" align="center">
                </el-table-column>
                <el-table-column prop="className" label="班级" align="center">
                </el-table-column>
            </el-table>
            <!-- <div class="pageWrap flex-align-around">
                <el-pagination background layout="prev, pager, next,total ,jumper" :page-size='5' :total="total"
                    @current-change="handleCurrentChange">
                </el-pagination>
            </div> -->
            <div class="confirm" @click="handleClose">
                确定
            </div>
        </el-dialog>
        <!-- 快捷输入弹窗 -->
        <el-dialog custom-class="fastInputDialog" :visible='dialogVisible3' :before-close="handleClose" center
            :title="currentTitle">
            <div class="wordContent flex-layout">
                <div class="fast_left">
                    <div class="write_wrap flex-align">
                        <div class="wirte active">单元字帖
                            <img src="@/assets/copybook/triangle.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="fast_right">
                    <div class="cell flex-align-between">
                        <span>选择单元:</span>
                        <el-select v-model="value" placeholder="请选择" @change='changeValue'>
                            <el-option v-for="(item, index) in options2" :key="index" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="chooseWord flex-align-between">
                        <span>已选择生字:{{ selectWordList.length > 0 ? selectWordList : '' }}</span>
                        <el-checkbox v-if="type == 2" v-model="checked">全选</el-checkbox>
                    </div>
                    <div class="wordWrap">
                        <div class="classItem flex-layout">
                            <div class="wordItem" :class="{ 'activeWordItem': selectWordList.includes(item.name) }"
                                v-for="(item, index) in words" :key="index" @click="selectWord(item.id, item.name)">
                                <img src="@/assets/copybook/mi1.png" alt="">
                                <span>{{ item.name }}</span>
                            </div>
                            <div class="wordItem-empty" v-for="(item, index) in (7 - (words.length % 7))"
                                :key="index + '0001'">
                            </div>
                        </div>
                    </div>
                    <div class="btn" @click="confirm">确定</div>
                </div>
            </div>

        </el-dialog>
    </div>
</template>

<script>
    import points from './coord.json'
    const OSS = require('ali-oss');
    export default {
        data() {
            return {
                coverUrl: this.$route.query.cover || '',
                coverPath: '',
                client: null,
                replaceBgUploading: false,
                isEditing: false,
                name: '',
                searchName: '',
                options2: [],
                checked: true,
                bindStu: '',
                value: '',
                textarea: '',
                dialogVisible: false,
                dialogVisible2: false,
                dialogVisible3: false,
                originData: [], // 学生列表原始数据
                tableData: [], // 学生列表分页数据
                type: 1,
                fastList: [],
                classList: [],
                className: '',
                points: points,
                gridType: 1,
                page: 1,
                limit: 5,
                total: null,
                // selectList: [],
                currnetGrade: null,
                words: [],
                detail: {
                    type: -1
                },
                bindStuList: [], //绑定学生数组
                bindStuListCopy: [], // 绑定学生数组备份
                allSelect: true,
                bindWordList: [], //快捷输入选字数组
                // disabled: false,
                schoolName: '',
                currentTitle: '',
                schoolVal: '',
                bindGrade: '',
                gradeList: [],
                maxlength: this.$route.query.maxlength,
                selectWordList: [],
                gradeId: null,
                bgImg: '',
                editTemplateId: null,
                isCheck: true // 默认为true,弹窗提示确认
            }
        },
        watch: {
            textarea: {
                handler(newval) {
                    console.log('监听字帖内容改变新值:', newval)
                    if (newval == '') {
                        this.selectWordList = []
                    } else {
                        this.selectWordList = newval.split('')
                    }
                },
            }
        },
        computed: {
            currentChineseCount() {
                const content = this.textarea || '';
                const onlyChinese = content.replace(/[^\u4e00-\u9fa5X]/g, '');
                return onlyChinese.length;
            },
            maxChineseCount() {
                return Number(this.$route.query.maxlength) || 0;
            },
            isMake() {
                if (this.name && this.textarea) {
                    return true
                } else {
                    return false
                }
            },
            isEditMode() {
                return this.$route.query.isEdit == 'true'
            },
            formEditable() {
                return !this.isEditMode || this.isEditing
            },
            replaceBgActive() {
                if (this.isEditMode && !this.isEditing) {
                    return false
                }
                return !this.replaceBgUploading
            }
        },
        mounted() {
            this.initOss();
            this.getGrade();
            this.getClassList();
            this.getUserInfo();
            if (this.$route.query.isEdit == 'true') {
                // 编辑模式
                this.copyBookDetail()
            }
        },
        methods: {
            async initOss() {
                let resData = await this.$Api.Upload.getQueryToken();
                this.client = new OSS({
                    region: 'oss-cn-beijing',
                    authorizationV4: true,
                    accessKeyId: resData.data.accessKeyId,
                    accessKeySecret: resData.data.accessKeySecret,
                    stsToken: resData.data.stsToken,
                    bucket: resData.data.bucket,
                    timeout: 60000 * 60 * 24
                })
            },
            uploadBackground(data) {
                if (!this.replaceBgActive || !this.client) {
                    this.$message.error('上传初始化失败，请刷新页面重试');
                    return;
                }
                this.replaceBgUploading = true;
                const localUrl = URL.createObjectURL(data.file);
                const currentDate = new Date();
                const year = currentDate.getFullYear();
                const month = currentDate.getMonth() + 1;
                const day = currentDate.getDate();
                const timestamp = currentDate.getTime() + '_' + Math.floor(Math.random() * 10000) + 1;
                const name = `copybook/user_background_img/${year}/${month}/${day}/copybook-bg-upload-${timestamp}.${data.file.type.split("/")[1]}`;
                this.client.put(name, data.file)
                    .then(() => {
                        this.coverPath = name;
                        this.bgImg = name;
                        if (this.coverUrl && this.coverUrl.startsWith('blob:')) {
                            URL.revokeObjectURL(this.coverUrl);
                        }
                        this.coverUrl = localUrl;
                        this.$message.success('背景替换成功');
                        console.log('背景图片路径:', name);
                    })
                    .catch(err => {
                        URL.revokeObjectURL(localUrl);
                        console.log('上传失败:', err);
                        this.$message.error('背景上传失败，请重试');
                    })
                    .finally(() => {
                        this.replaceBgUploading = false;
                    })
            },
            goback() {
                this.$router.go(-1);
                this.$route.name == 'curriculum' ? sessionStorage.removeItem("type") : '';
            },
            clear() {
                if (!this.formEditable) {
                    return
                }
                this.textarea = '';
                this.selectWordList = [];
            },
            handleClose() {
                this.dialogVisible = false;
                this.dialogVisible2 = false;
                this.dialogVisible3 = false;
                // this.disabled = false;
                this.searchName = ''
            },
            create() {
                if (!this.isMake) {
                    return
                }
                if (!this.name) {
                    this.$message({
                        message: '字帖名称不能为空',
                        type: 'warning'
                    });
                    return
                }
                // if (!this.bindStu) {
                //     this.$message({
                //         message: '请先选择班级',
                //         type: 'warning'
                //     });
                //     return
                // }
                if (!this.textarea) {
                    this.$message({
                        message: '字帖内容不能为空',
                        type: 'warning'
                    });
                    return
                }

                let data = {
                    words: this.textarea,
                    tempId: this.editTemplateId || this.$route.query.type,
                    type: 99,
                    name: this.name,
                    userIds: this.bindStuList,
                    gradeId: this.gradeId,
                    cover: this.coverPath || this.coverUrl,
                    bgImg: this.bgImg,
                    isCheck: this.isCheck
                }
                this.$Api.CopyBook.createCopyBook(data)
                    .then(res => {
                        console.log('创建字帖成功', res);
                        if (res.code == 500) {
                            // if (this.$route.query.isWriteAnyOrder == 'false') {
                            //     this.$message.error(res.msg);
                            // } else {
                            let msg = res.msg;
                            this.$confirm(msg, '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                this.isCheck = false;
                                this.create();
                            }).catch(() => {
                                // this.$message.error('已取消');
                                console.log('已取消');
                            });
                            // let noWordList = res.msg.split('：')[1].split('、');
                            // this.$alert(msg, '提示', {
                            // confirmButtonText: '一键清除',
                            // callback: action => {
                            // console.log('一键清除的字---', noWordList);
                            // noWordList.map(item => {
                            //     this.textarea = this.textarea.replace(item, '');
                            // })
                            // }
                            // });
                            // }
                            return
                        }
                        this.dialogVisible = true;
                    })
                    .catch(err => {
                        console.log('创建字帖失败', err);
                        this.$message.error('创建失败，请联系管理员');
                    })
            },
            check() {
                this.handleClose();
                // this.$router.go(-1)
                let query = {
                    fromPath: 'createWord'
                }
                // this.$router.push({
                //     path: '/copybook',
                //     query
                // })
                this.$router.replace({
                    path: '/copybook',
                    query
                })
            },
            changeClass(val) {
                console.log('val---', val);
                this.gradeId = this.classList.find(item => item.id === val).termId
                this.bindStuList = [];
                let index = this.classList.findIndex(item => {
                    return item.id == val
                })
                this.className = this.classList[index].name;
                // 选择班级默认选中该班级全部学生
                let data = {
                    classId: this.bindStu,
                    page: 1,
                    limit: 999,
                }
                this.$Api.CopyBook.getClassStu(data)
                    .then(res => {
                        console.log('学员列表', res);
                        res.data.map(item => {
                            item.className = this.className;
                            item.select = true;
                            this.bindStuList.push(item.id);
                            this.bindStuListCopy.push(item.id);
                        })
                        this.originData = res.data;
                        this.tableData = res.data;
                    })
                    .catch(err => {
                        console.log('获取学员失败--', err)
                    })
            },
            chooseWrod(grade, name) {
                if (!this.formEditable) {
                    return
                }
                this.currnetGrade = grade;
                this.currentTitle = name;
                this.dialogVisible3 = true;
                this.getCellList();
            },
            chooseStu(classId) {
                if (!this.formEditable) {
                    return
                }
                if (!classId) {
                    this.$message({
                        message: '请先选择班级',
                        type: 'warning'
                    });
                    return
                }
                this.searchName = '';
                this.getStuList();
                this.dialogVisible2 = true
            },
            getStuList() {
                // 根据班级id获取学生
                // 根据本地数据originData手动本地分页不走接口
                if (this.searchName) {
                    console.log("根据搜索姓名查询:", this.searchName);
                    this.tableData = this.originData.filter(item => {
                        return item.name.includes(this.searchName)
                    });
                    this.total = this.tableData.length;
                } else {
                    this.tableData = this.originData
                    // this.tableData = this.originData.slice((this.page - 1) * 5, this.page * 5);
                    // this.total = this.originData.length
                }
            },
            // 获取快捷输入班级列表
            getGrade() {
                this.$Api.Home.getCourseInfo()
                    .then(res => {
                        console.log('获取快捷输入班级列表', res);
                        this.fastList = res.data
                    })
                    .catch(err => {
                        console.log('获取年级失败', err)
                    })
            },
            // 快捷输入弹窗 单元列表
            async getCellList() {
                let data = {
                    type: 1,
                    gradeId: this.currnetGrade,
                    term: 2025
                }
                let resData = await this.$Api.Home.getNewMyTeachCell(data);
                console.log('获取单元', resData);
                this.options2 = resData.data;
                this.value = resData.data[0].id;
                this.getWordList(this.value);
            },
            // 选择单元
            async changeValue(val) {
                this.getWordList(val);
            },
            // 获取绑定学生选择班级列表
            getClassList() {
                return this.$Api.CopyBook.getClassList()
                    .then(res => {
                        this.classList = res.data;
                        return res.data;
                    })
                    .catch(err => {
                        console.log('获取班级失败', err)
                    })
            },
            // 选择格子类型
            chooseGrid(type) {
                this.gridType = type
            },
            handleCurrentChange(page) {
                console.log('当前页--', page)
                this.page = page;
                this.getStuList()
            },
            handleSelectionChange(selection) {
                console.log('selection---', selection);
                // selection.map(item => {
                //     this.selectList.push(item)
                // })
                // this.selectList = [...new Set(this.selectList.map(item => {
                //     return JSON.stringify(item)
                // }))].map(item => {
                //     return JSON.parse(item)
                // });
                // console.log('去重后的数组--', this.selectList);
            },
            searchStu(name) {
                console.log('搜索的参数--', name);
                if (name.trim()) {
                    this.getStuList()
                } else {
                    this.tableData = this.originData
                    // this.tableData = this.originData.slice(0, 5);
                    // this.total = this.originData.length
                }
            },
            // 选中/取消选中学员
            selectStu(stuid, status) {
                if (!status) {
                    // 取消选中
                    this.allSelect = false;
                    let index = this.bindStuList.findIndex(item => item == stuid);
                    this.bindStuList.splice(index, 1)
                } else {
                    // 选中
                    this.bindStuList.push(stuid);
                    if (this.bindStuList.length == this.originData.length) {
                        this.allSelect = true
                    }
                }
            },
            // 全选/全不选学生
            changeAll(val) {
                console.log(val);
                if (val) {
                    // 这里注意需要进行深拷贝
                    this.bindStuList = JSON.parse(JSON.stringify(this.bindStuListCopy));
                    // 添加每个学生的选中状态
                    this.originData.map(item => {
                        item.select = true;
                    })
                } else {
                    this.bindStuList = [];
                    // 取消每个学生的选中状态
                    this.originData.map(item => {
                        item.select = false;
                    })
                }
            },
            // 全选/全不选周
            changeWeek(index) {
                console.log(this.words[index].checked);
                if (this.words[index].checked) {
                    this.words[index].wordList.map(item => {
                        item.checked = true;
                        this.addBindWordList(item.wordName, 'add')
                    })
                } else {
                    this.words[index].wordList.map(item => {
                        item.checked = false;
                        this.addBindWordList(item.wordName, 'delete')
                    })
                }
            },
            // 快捷输入弹窗选择字
            chooseWord(index, childIndex) {
                // console.log('父index--',index,'子index',childIndex);
                this.$set(this.words[index].wordList, childIndex, {
                    ...this.words[index].wordList[childIndex],
                    checked: !this.words[index].wordList[childIndex].checked
                })
                // 判断当前周数组中是否全选
                for (var i = 0; i < this.words[index].wordList.length; i++) {
                    if (!this.words[index].wordList[i].checked) {
                        this.words[index].checked = false;
                        break
                    } else {
                        this.words[index].checked = true;
                    }
                }
                // 将当前选字添加到 bindWordList(快捷输入选字数组)
                if (this.words[index].wordList[childIndex].checked) {
                    this.addBindWordList(this.words[index].wordList[childIndex].wordName, 'add')
                } else {
                    this.addBindWordList(this.words[index].wordList[childIndex].wordName, 'delete')
                }

            },
            // 添加字
            addBindWordList(word, type) {
                // type -- add添加,delete删除
                if (type == 'add') {
                    if (this.bindWordList.indexOf(word) < 0) {
                        this.bindWordList.push(word)
                    }
                } else {
                    let index = this.bindWordList.indexOf(word);
                    this.bindWordList.splice(index, 1)
                }

            },
            // 快捷输入确认按钮
            confirm() {
                this.dialogVisible3 = false;
                this.textarea = this.selectWordList.join('')
            },
            // 获取用户信息
            async getUserInfo() {
                let resData = await this.$Api.Home.getUserInfo();
                // console.log('resData', resData);
                this.schoolName = resData.data.schoolName
            },
            // 管理员输入学校名称
            changeSchool(val) {
                console.log(val);
                if (val.trim()) {

                }
            },
            // 根据学校名称获取年级
            getGradeList(schoolId) {
                console.log('学习id:', schoolId)
            },
            // 根据年级获取班级列表
            getClassListByGrade(gradeId) {
                console.log('年级Id:', gradeId)
            },
            //  ---------- 编辑字帖 ----------
            startEdit() {
                if (this.isEditing) {
                    return
                }
                this.isEditing = true
            },
            copyBookDetail() {
                let data = {
                    id: this.$route.query.modelId
                }
                this.$Api.CopyBook.editCopyBook(data)
                    .then(async res => {
                        console.log('编辑字帖详情', res);
                        if (res.code != 200 || !res.data) {
                            return
                        }
                        const detail = res.data
                        const genJsonObj = detail.genJsonObj || {}
                        this.name = detail.name || ''
                        this.textarea = detail.words || ''
                        this.gradeId = detail.gradeId || null
                        this.editTemplateId = detail.templateId || null
                        const selectedIds = genJsonObj['学生ids'] || []
                        this.bindStuList = selectedIds
                        this.bindStuListCopy = [...selectedIds]
                        const backgroundImg = (genJsonObj.background_img || '').replace(/^\//, '')
                        this.bgImg = backgroundImg
                        if (backgroundImg) {
                            this.coverPath = backgroundImg
                            let resData = await this.$Api.Upload.getTempUrl({ path: backgroundImg })
                            this.coverUrl = resData.data
                        } else if (this.$route.query.cover) {
                            this.coverUrl = this.$route.query.cover
                        }
                        const loadStudents = () => {
                            this.loadEditBindStudents(detail, selectedIds)
                        }
                        if (this.classList.length) {
                            loadStudents()
                        } else {
                            this.getClassList().then(loadStudents)
                        }
                    })
                    .catch(err => {
                        console.log('编辑字帖详情失败', err)
                    })
            },
            loadEditBindStudents(detail, selectedIds) {
                if (!selectedIds.length) {
                    return
                }
                if (detail.classId) {
                    this.bindStu = detail.classId
                    this.loadEditClassStudents(detail.classId, selectedIds)
                    return
                }
                this.findClassByStudentIds(selectedIds)
            },
            async findClassByStudentIds(selectedIds) {
                for (let i = 0; i < this.classList.length; i++) {
                    const item = this.classList[i]
                    try {
                        let res = await this.$Api.CopyBook.getClassStu({
                            classId: item.id,
                            page: 1,
                            limit: 999,
                        })
                        const hasSelected = (res.data || []).some(stu => selectedIds.includes(stu.id))
                        if (hasSelected) {
                            this.bindStu = item.id
                            this.loadEditClassStudents(item.id, selectedIds)
                            return
                        }
                    } catch (err) {
                        console.log('查找学生班级失败--', err)
                    }
                }
            },
            loadEditClassStudents(classId, selectedIds) {
                const classItem = this.classList.find(item => item.id === classId)
                if (!classItem) {
                    return
                }
                this.gradeId = classItem.termId
                this.className = classItem.name
                let data = {
                    classId,
                    page: 1,
                    limit: 999,
                }
                this.$Api.CopyBook.getClassStu(data)
                    .then(res => {
                        const selectedSet = new Set(selectedIds || [])
                        res.data.map(item => {
                            item.className = this.className
                            item.select = selectedSet.has(item.id)
                        })
                        this.originData = res.data
                        this.tableData = res.data
                        this.bindStuList = selectedIds || []
                        this.bindStuListCopy = res.data.filter(item => item.select).map(item => item.id)
                        this.allSelect = this.bindStuList.length === res.data.length
                    })
                    .catch(err => {
                        console.log('获取学员失败--', err)
                    })
            },
            // 获取字列表
            async getWordList(unitId) {
                let data = {
                    unitId,
                    courseType: 12
                }
                let resData = await this.$Api.Home.queryWordsNew(data);
                console.log('获取字列表:', resData);
                this.words = resData.data;
            },
            // 选择字
            selectWord(id, name) {
                let index = this.selectWordList.indexOf(name);
                if (index > -1) {
                    this.selectWordList.splice(index, 1)
                } else {
                    if (this.selectWordList.length == this.$route.query.maxlength) {
                        this.$message.error('该字帖最多只能选择' + this.$route.query.maxlength + '个字');
                        return;
                    }
                    this.selectWordList.push(name)
                }

            },
            handleInput(value) {
                const maxChineseCount = Number(this.$route.query.maxlength) || 0;
                const onlyChinese = value.replace(/[^\u4e00-\u9fa5X]/g, '');
                this.textarea = maxChineseCount > 0 ? onlyChinese.slice(0, maxChineseCount) : onlyChinese;
            }
        },
    }
</script>
<style scoped lang='less'>
    @import "./less/createWord.less";

    .wordCount {
        margin-top: 6px;
        text-align: right;
        color: #999;
        font-size: 12px;
        line-height: 1;
    }
</style>